const theme = {
	palette: {
		primary: {
			light: '80a4cd',
			main: '#255084',
		},
		secondary: {
			main: '#80a4cd',
		},
	},
};

export default theme;
